// import { getPropByPath } from '../../utils/util';
import AriaUtils from '../../utils/aria-utils';

export const cellStarts = {
  default: {
    minWidth: 120,
    className: '',
    order: ''
  },
  selection: {
    width: 28,
    minWidth: 28,
    order: '',
    className: 'zm-table-column--selection'
  },
  expand: {
    width: 20,
    minWidth: 20,
    realWidth: 20,
    order: ''
  },
  index: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  },
  draggable: {
    width: 20,
    minWidth: 20,
    realWidth: 20,
    order: ''
  }
};

// 这些选项不应该被覆盖
export const cellForced = {
  selection: {
    renderHeader: function(h, { column, store }) {
      const disabled = column.selectableHeader ? !column.selectableHeader.call(null, store.states.data) : store.states.data && store.states.data.length === 0;
      return <zm-checkbox
        disabled={disabled}
        indeterminate={store.states.selection.length > 0 && !this.isAllSelected}
        aria-label="Select All"
        on-change={() => {
          this.toggleAllSelection(null);
        }}
        // nativeOn-click={this.toggleAllSelection}
        disable-transition={store.states.data && store.states.data.length > 100}
        value={this.isAllSelected}/>;
    },
    renderCell: function(h, { row, column, store, $index, isSelectedRow, disableTransition }) {
      const disabled = column.selectable ? !column.selectable.call(null, row, $index) : false;

      const checkbox = <zm-checkbox
        nativeOn-click={(event) => event.stopPropagation()}
        value={isSelectedRow}
        disabled={disabled}
        title={column.renderTitle ? column.renderTitle.call(null, row, $index) : ''}
        aria-label={disabled ? 'This Row is Disabled' : 'Select This Row'}
        on-input={() => {
          store.commit('rowSelectedChanged', row);
        }}
        disable-transition={disableTransition}
      />;

      const iconLock = <span
        class="zm-icon-locked"
        aria-label="This Row is locked"
        title={column.renderTitle ? column.renderTitle.call(null, row, $index) : ''}
      ></span>;

      const isLock = column.lockable && column.lockable.call(null, row, $index);

      return isLock ? iconLock : checkbox;
    },
    sortable: false,
    resizable: false
  },
  index: {
    renderHeader: function(h, { column }) {
      return (
        <span tabIndex={-1}>
          {column.label || '#'}
        </span>
      );
    },
    renderCell: function(h, { $index, column }) {
      let i = $index + 1;
      const index = column.index;

      if (typeof index === 'number') {
        i = $index + index;
      } else if (typeof index === 'function') {
        i = index($index);
      }

      return <div>{i}</div>;
    },
    sortable: false
  },
  expand: {
    renderHeader: function(h, { column }) {
      return column.label || '';
    },
    renderCell: function(h, { row, store }) {
      const classes = ['zm-table__expand-icon'];
      if (store.states.expandRows.indexOf(row) > -1) {
        classes.push('zm-table__expand-icon--expanded');
      }
      const callback = function(e) {
        e.stopPropagation();
        store.toggleRowExpansion(row);
      };

      const handleKeyDown = function(e) {
        const keyCode = e.keyCode;
        const keys = AriaUtils.keys;
        switch (keyCode) {
          case keys.enter:
          case keys.space:
            callback(e);
            e.preventDefault();
            break;
        }
      };

      const isExpandedRow = function() {
        return store.isRowExpanded(row) ? 'true' : 'false';
      };

      return (<div
        tabIndex={-1}
        role="button"
        class={classes}
        on-click={callback}
        on-keydown={handleKeyDown}
        aria-haspopup={true}
        aria-expanded={isExpandedRow()}
      >
        <i class='zm-icon zm-icon-right'></i>
      </div>);
    },
    sortable: false,
    resizable: false,
    className: 'zm-table__expand-column'
  },
  draggable: {
    renderHeader() {
      return '';
    },
    renderCell(h, { store, $index }) {
      const hoverRow = store.states.hoverRow;
      if ($index === hoverRow) {
        return (
          <i class="zm-icon-dnd"></i>
        );
      }

      return '';
    },
    sortable: false,
    resizable: false
  }
};

export function defaultRenderCell(h, { row, column, $index }) {
  const property = column.property;
  const value = row[property];
  // const value = property && getPropByPath(row, property).v;
  if (column && column.formatter) {
    return column.formatter(row, column, value, $index);
  }
  return value;
}

export function treeCellPrefix(h, { row, treeNode, store, column }) {
  if (!treeNode || column.noColumnPrefix) return null;
  const ele = [];
  const callback = function(e) {
    e.stopPropagation();
    store.loadOrToggle(row);
  };
  if (treeNode.indent) {
    ele.push(<span class="zm-table__indent" style={{ 'padding-left': treeNode.indent + 'px' }}></span>);
  }
  if (typeof treeNode.expanded === 'boolean' && !treeNode.noLazyChildren) {
    const expandClasses = ['zm-table__expand-icon', treeNode.expanded ? 'zm-table__expand-icon--expanded' : ''];
    let iconClasses = ['zm-icon-right'];
    if (treeNode.loading) {
      iconClasses = ['zm-icon-loading'];
    }
    const handleKeyDown = function(e) {
      const keyCode = e.keyCode;
      const keys = AriaUtils.keys;
      switch (keyCode) {
        case keys.enter:
        case keys.space:
          callback(e);
          e.preventDefault();
          break;
      }
    };
    ele.push(<div
      tabindex="-1"
      role="button"
      class={expandClasses}
      on-click={callback}
      on-keydown={handleKeyDown}
      aria-haspopup={true}
      aria-expanded={treeNode.expanded ? 'true' : 'false'}>
      <i class={iconClasses}></i>
    </div>);
  } else {
    ele.push(<span class="zm-table__placeholder"></span>);
  }
  return ele;
}
